var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupe11521(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 277,
    height: 277,
    viewBox: "0 0 277 277",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_178_115)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138.464 276.478C161.542 276.49 184.25 270.677 204.484 259.576C224.718 248.476 241.822 232.448 254.213 212.978H22.7148C35.1053 232.448 52.2099 248.476 72.4435 259.576C92.6772 270.677 115.385 276.49 138.464 276.478Z",
    fill: "#D9DCDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M189.382 42.163H87.5469V212.19H189.382V42.163Z",
    fill: "#FEFEFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M189.382 42.163H87.5469V212.19H189.382V42.163Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8867 212.543H254.351",
    stroke: "black",
    strokeWidth: 1.415,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M131.216 142.125H103.084V200.02H131.216V142.125Z",
    fill: "#E8EDEF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M173.386 142.125H145.254V200.02H173.386V142.125Z",
    fill: "#E8EDEF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M130.997 73.647H102.865V131.542H130.997V73.647Z",
    fill: "#E8EDEF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M173.167 73.647H145.035V131.542H173.167V73.647Z",
    fill: "#E8EDEF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M108.614 82.337L137.851 45.822L160.47 77.265",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M181.325 136.484C181.325 137.853 180.919 139.192 180.158 140.331C179.398 141.469 178.316 142.357 177.051 142.881C175.786 143.405 174.394 143.542 173.051 143.275C171.708 143.008 170.474 142.349 169.506 141.38C168.538 140.412 167.879 139.178 167.611 137.835C167.344 136.492 167.482 135.1 168.006 133.835C168.53 132.57 169.417 131.489 170.556 130.728C171.695 129.968 173.033 129.562 174.403 129.562C176.238 129.562 177.999 130.291 179.297 131.589C180.595 132.888 181.325 134.648 181.325 136.484Z",
    fill: "#D9DCDD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M180.09 132.6C180.09 133.969 179.684 135.308 178.924 136.447C178.163 137.585 177.082 138.473 175.817 138.997C174.552 139.521 173.16 139.658 171.817 139.391C170.474 139.124 169.24 138.465 168.272 137.496C167.304 136.528 166.644 135.294 166.377 133.951C166.11 132.608 166.247 131.216 166.771 129.951C167.295 128.686 168.183 127.605 169.322 126.844C170.46 126.084 171.799 125.678 173.168 125.678C175.004 125.678 176.765 126.407 178.063 127.705C179.361 129.004 180.09 130.764 180.09 132.6Z",
    fill: "#FEFEFE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M180.09 132.6C180.09 133.969 179.684 135.308 178.924 136.447C178.163 137.585 177.082 138.473 175.817 138.997C174.552 139.521 173.16 139.658 171.817 139.391C170.474 139.124 169.24 138.465 168.272 137.496C167.304 136.528 166.644 135.294 166.377 133.951C166.11 132.608 166.247 131.216 166.771 129.951C167.295 128.686 168.183 127.605 169.322 126.844C170.46 126.084 171.799 125.678 173.168 125.678C175.004 125.678 176.765 126.407 178.063 127.705C179.361 129.004 180.09 130.764 180.09 132.6Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M182.179 124.291L105.013 130.629L100.759 82.337L179.029 74.594L182.179 124.291Z",
    fill: "#D9DCDD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M174.118 75.9289L97.3203 83.44L101.584 127.03L178.381 119.519L174.118 75.9289Z",
    fill: "#FEFEFE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M174.118 75.9289L97.3203 83.44L101.584 127.03L178.381 119.519L174.118 75.9289Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M118.77 107.592L118.39 103.692L109.057 104.602L108.357 101.464L116.043 88.5646L121.03 88.0785L122.176 99.8354L124.712 99.5882L125.048 103.043L122.513 103.29L122.893 107.19L118.77 107.592ZM112.648 100.764L118.053 100.237L117.331 92.8266L112.648 100.764ZM136.283 106.223C131.24 106.714 127.303 102.964 126.735 97.141C126.17 91.3461 129.309 86.9057 134.352 86.4141C139.395 85.9225 143.36 89.6703 143.925 95.4652C144.493 101.288 141.326 105.731 136.283 106.223ZM135.919 102.489C138.51 102.237 140.041 99.472 139.69 95.878C139.34 92.2841 137.307 89.8948 134.716 90.1474C132.153 90.3973 130.592 93.1369 130.942 96.7309C131.293 100.325 133.356 102.739 135.919 102.489ZM156.506 103.914L156.126 100.013L146.793 100.923L146.093 97.785L153.779 84.8858L158.766 84.3997L159.912 96.1566L162.448 95.9094L162.785 99.3641L160.249 99.6112L160.629 103.512L156.506 103.914ZM150.384 97.0855L155.789 96.5586L155.067 89.1478L150.384 97.0855Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_178_115",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 277,
    height: 277
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M276.929 0H0V276.929H276.929V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_178_115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.6309 230.709H87.7989",
    stroke: "#8C999F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.34 242.35H225.241",
    stroke: "#8C999F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.382 233.708H199.34",
    stroke: "#8C999F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9062 216.952H94.5472",
    stroke: "#8C999F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.264 247.112H117.799",
    stroke: "#8C999F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.637 275.686C214.422 275.591 275.781 214.078 275.685 138.293C275.59 62.508 214.077 1.14933 138.292 1.24456C62.5072 1.3398 1.14849 62.8529 1.24373 138.638C1.33896 214.423 62.852 275.782 138.637 275.686Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.637 275.686C214.422 275.591 275.781 214.078 275.685 138.293C275.59 62.508 214.077 1.14933 138.292 1.24456C62.5072 1.3398 1.14849 62.8529 1.24373 138.638C1.33896 214.423 62.852 275.782 138.637 275.686Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_178_115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 276.929,
    height: 276.929,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupe11521);
export default __webpack_public_path__ + "static/media/Groupe 1152 1.70ffa7b5f66b423cf0415d748d9456c1.svg";
export { ForwardRef as ReactComponent };